export default function formatFullDetails(value: string | boolean) {
  let formattedValue;
  switch (value) {
    case true:
    case 'Y':
      formattedValue = 'Yes';
      break;
    case false:
    case 'No Pool':
    case 'None':
    case 'N':
      formattedValue = 'No';
      break;
    default:
      formattedValue = value;
  }

  return formattedValue;
}
